module.exports = __webpack_public_path__ + "static/media/2_PackageSend.6a8d70e9.png";